import { createAction, props } from "@ngrx/store";
import { IFinantialReport } from "src/app/shared/interfaces/finantial-report/ifinantial-report";

enum FinantialReportActionType {
    LOAD_FINANTIAL_REPORT = '[finantial report] load notas fiscais report from api',
    LOAD_FINANTIAL_REPORT_SUCCESS = '[finantial report] load notas fiscais report from api return success'
}


const loadFinantialReport = createAction(
    FinantialReportActionType.LOAD_FINANTIAL_REPORT
);

const loadFinantialReportSuccess = createAction(
    FinantialReportActionType.LOAD_FINANTIAL_REPORT_SUCCESS,
    props<{ finantial_report: IFinantialReport }>()
);

export const finantialReportActions = {
    loadFinantialReport,
    loadFinantialReportSuccess
}